import React from "react";
import { Link } from "react-router-dom";

export default function VehicleCard({ vehicule }) {
  return (
    <Link to={`/vehicules/${vehicule.slug}`} className="text-decoration-none text-dark">
      <div className="card h-100 shadow-sm">
        <img
          src={vehicule.imageUrls?.[0] || "https://via.placeholder.com/300x200?text=Pas+d'image"}
          className="card-img-top"
          alt={`${vehicule.marque} ${vehicule.modele}`}
          style={{ height: "180px", objectFit: "cover" }}
        />
        <div className="card-body">
          <h5 className="card-title mb-1">{vehicule.marque} {vehicule.modele}</h5>
          
          {vehicule.annee && <p className="card-text">Année : {vehicule.annee}</p>}
        </div>
      </div>
    </Link>
  );
}
